import { Pagination, Tag } from "antd";
import { parseAsInteger, useQueryState } from "nuqs";
import { QData } from "../../types/basic-type-list";

type MyPaginationProps = {
  qData: QData;
  total: number;
  DEFAULT_NUQS_CONFIG: object;
  onChange?: (newQData: QData) => void;
};

export default function MyPagination(props: MyPaginationProps) {
  const { qData, total, DEFAULT_NUQS_CONFIG } = props;

  const [page, setPage] = useQueryState(
    "page",
    parseAsInteger.withOptions(DEFAULT_NUQS_CONFIG).withDefault(qData.page ?? 1)
  );

  const [pageLimit, setPageLimit] = useQueryState(
    "limit",
    parseAsInteger.withOptions(DEFAULT_NUQS_CONFIG).withDefault(qData.limit ?? 10)
  );

  const handleChange = (newPage: number, newLimit: number) => {
    setPage(newPage);
    setPageLimit(newLimit);

    props?.onChange?.({
      ...qData,
      page: newPage,
      limit: newLimit,
    });
  };

  const showTotal = () => {
    const start = (page - 1) * pageLimit + 1;
    const end = Math.min(page * pageLimit, total);
    return <Tag>{`Showing ${start} - ${end} out of ${total}`}</Tag>;
  };

  return total > 0 ? (
    <div className="flex justify-end items-center">
      <Pagination
      current={page}
      pageSize={pageLimit}
      total={total}
      onChange={handleChange}
      showSizeChanger={true}
      showTotal={showTotal}
    />
    </div>
  ) : null;
}
